import { NgModule } from "@angular/core";
import { ContactsRoutingModule } from "./contacts-routing.module";
import { ContactdetailComponent } from "./contactdetail/contactdetail.component";
import { AddcontactComponent } from "./addcontact/addcontact.component";
import { ContactsComponent } from "./contact-list/contacts.component";
import { EditcontactComponent } from "./editcontact/editcontact.component";

import { SharedModule } from "../../shared/shared.module";

@NgModule({
  declarations: [
    AddcontactComponent,
    ContactsComponent,
    EditcontactComponent,
    ContactdetailComponent,
  ],
  imports: [ContactsRoutingModule, SharedModule],
})
export class ContactsModule {}
